import Image from "next/image";
import { DownOutlined } from "@ant-design/icons";

import { navigateToProducts } from "@utils/navigate-to-products";
import Pattern from "@public/images/pattern.png";

import styles from "../poster.module.css";

export const FocusColumn = () => (
  <div className={styles.left}>
    <div className={styles.header}>
      <Image className={styles.pattern} src={Pattern} alt={"pattern"} />
      <h1 className={styles.title}>
        Доставка шашлыков и&nbsp;антрекотов из тандыра по Томску
      </h1>
      <p className={styles.description}>Срочно и горячо!</p>
    </div>
    <button className={styles.navigateButton} onClick={navigateToProducts}>
      <p className={styles.text}>К ассортименту</p>
      <DownOutlined className={styles.shevron} />
    </button>
  </div>
);
